import { buildCollection, buildProperty } from "@firecms/core";
import type { ContentScopeId } from "../workspace/collectionIds";
import type { LevelProgress } from "../types/participantProgress";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import type { Locale } from "../localization/constants";
import { buildLevelProgressDurationField } from "../properties/levelProgressDuration";
import { StarsPreview } from "../properties/starsPreview";

export type { LevelProgress, LevelState } from "../types/participantProgress";

export const buildLevelProgressCollection = (
  contentScopeId: ContentScopeId,
  locale: Locale = getAdminUiLocale()
) => {
  const t = getAdminT(locale);
  void contentScopeId;
  return buildCollection<LevelProgress>({
    name: t("participantProgress.progressCollectionName"),
    singularName: t("participantProgress.progressSingularName"),
    description: t("participantProgress.progressDescription"),
    path: "levelProgress",
    id: "level_progress",
    icon: "Timeline",
    defaultSize: "s",
    selectionEnabled: false,
    permissions: () => ({
      read: true,
      edit: false,
      create: false,
      delete: false,
    }),
    propertiesOrder: [
      "levelCode",
      "unitCode",
      "score",
      "stars",
      "state",
      "startedAt",
      "duration",
      "levelId",
      "unitId",
    ],
    additionalFields: [buildLevelProgressDurationField(locale)],
    properties: {
      levelCode: buildProperty({
        name: "Level",
        dataType: "string",
      }),
      unitCode: buildProperty({
        name: "Unit",
        dataType: "string",
      }),
      levelId: buildProperty({
        name: "Level id",
        dataType: "string",
        hideFromCollection: true,
      }),
      unitId: buildProperty({
        name: "Unit id",
        dataType: "string",
        hideFromCollection: true,
      }),
      score: buildProperty({
        name: "Score",
        dataType: "number",
      }),
      stars: buildProperty({
        name: "Stars",
        dataType: "number",
        Preview: StarsPreview,
      }),
      state: buildProperty({
        name: "Status",
        dataType: "string",
        enumValues: {
          not_started: "Not started",
          in_progress: "In progress",
          completed: "Completed",
        },
      }),
      startedAt: buildProperty({
        name: "Started at",
        dataType: "date",
        mode: "date_time",
      }),
      completedAt: buildProperty({
        name: "Completed at",
        dataType: "date",
        mode: "date_time",
        hideFromCollection: true,
      }),
    },
  });
};
